// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCarousel from 'vue-carousel'
import VueAgile from 'vue-agile'
import vueScrollto from 'vue-scrollto'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueYouTubeEmbed from 'vue-youtube-embed'

export const ToggleBus = new Vue()

Vue.use(VueYouTubeEmbed)
Vue.use(VueAxios, axios)
Vue.use(vueScrollto)
Vue.use(VueAgile)
Vue.use(VueCarousel)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js